//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mpvueCityPicker from '@/components/mpvue-citypicker/mpvueCityPicker.vue'
export default {
	data() {
		return {
			addressData: {
				deliveryAddressId: 0,
				receiverName: '',
				phone: '',
				addressName: '',
				provinceCode: '',
				cityCode: '',
				districtCode: '',
				detailAddress: '',
				status: 0
			},
			themeColor: '#007AFF',
			cityPickerValueDefault: [0, 0, 0],
			id: '',
			active:false
		}
	},
	components: {
		mpvueCityPicker
	},
	computed:{
		disabled(){
			if(this.addressData.receiverName&&this.addressData.phone&&this.addressData.detailAddress&&this.addressData.addressName){
				return false
			} else {
				return true
			}
		}
	},
	onLoad(event) {
		this.id = event.id
		if (event.id) {
			uni.setNavigationBarTitle({
				title: '编辑收货地址'
			})
			this.queryData()
		} else{
			uni.setNavigationBarTitle({
				title: '新增收货地址'
			})
		}
	},
	methods: {
		queryData() {
			this.$ajax({
				method: 'post',
				url: '/weChat/specialtyProduct/queryDeliveryAddressInfo',
				data: {
					memberId: this.$store.state.userInfo.memberId,
					deliveryAddressId: this.id
				}
			}).then(res => {
				this.addressData = res.data
				this.addressData.addressName = res.data.provinceName + res.data.cityName + res.data.districtName
				this.active =res.data.status === 1 ? true : false
			})
		},
		onConfirm(e) {
			this.addressData.provinceCode = e.cityCode.substring(0, 2) + '0000000000'
			this.addressData.cityCode = e.cityCode.substring(0, 4) + '00000000'
			this.addressData.districtCode = e.cityCode + '000000'
			this.addressData.addressName = e.label
		},
		submit() {
			for (let key in this.addressData) {
				if (this.addressData[key] === '' || this.addressData[key] === '收件地区') {
					uni.showToast({
						title: '必填项不能为空',
						icon: 'none'
					})
					return
				}
			}
			if(!this.testName()){
				uni.showToast({
					title: '联系人不可包含特殊字符和数字',
					icon: 'none'
				})
			} else if(!this.testPhone()){
				uni.showToast({
					title: '请输入正确的手机号',
					icon: 'none'
				})
			} else{
				this.addressData.address = this.addressData.addressName + this.addressData.detailAddress
				this.$ajax({
					method: 'post',
					url: this.addressData.deliveryAddressId === 0 ? '/weChat/specialtyProduct/addDeliveryAddress' : '/weChat/specialtyProduct/updateDeliveryAddress',
					data: {
						...this.addressData,
						memberId: this.$store.state.userInfo.memberId
					}
				}).then(res => {
					uni.setStorageSync('refresh', true)
					uni.navigateBack({
						delta: 1
					})
				})
			}
		},
		switchChange() {
			this.active = !this.active
			this.addressData.status = this.active ? 1 : 0
		},
		showMulLinkageThreePicker() {
			this.$refs.mpvueCityPicker.show()
		},
		receiverName(e) {
			this.addressData.receiverName = e.target.value
		},
		testName(){
			return /^[\u4E00-\u9FA5A-Za-z]+$/.test(this.addressData.receiverName)
		},
		testPhone(){
			return /^1[345789]\d{9}$/.test(this.addressData.phone)
		},
		phone(e) {
			this.addressData.phone = e.target.value
		},
		detailAddress(e) {
			this.addressData.detailAddress = e.target.value
		},
		onCancel() {},
	},
}
